import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import type { Banner } from '../../../../../apps/hooks/banner/useBanner';
import BannerEditForm from './BannerEditForm';

interface EditBannerModalProps {
  show: boolean;
  onHide: () => void;
  editingBanner: Banner | null;
  handleInputChange: (field: keyof Banner, value: any) => void;
  handleSave: () => void;
}

const EditBannerModal: React.FC<EditBannerModalProps> = ({
  show,
  onHide,
  editingBanner,
  handleInputChange,
  handleSave,
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Edit Banner</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <BannerEditForm editingBanner={editingBanner} handleInputChange={handleInputChange} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditBannerModal;
